var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumeParserHeaderDarkicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2656 9.69162C9.24443 9.27955 9.57283 8.93384 9.98544 8.93384C10.3955 8.93384 10.723 9.27547 10.7056 9.68516L10.3921 17.0789C10.3836 17.279 10.2189 17.4368 10.0187 17.4368C9.8197 17.4368 9.65561 17.2809 9.6454 17.0822L9.2656 9.69162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6263 9.69076C11.6009 9.28052 11.9268 8.93384 12.3378 8.93384C12.7466 8.93384 13.0716 9.27694 13.0495 9.68514L12.7279 15.633C12.7173 15.8278 12.5564 15.9802 12.3613 15.9802C12.1675 15.9802 12.007 15.8294 11.995 15.6359L11.6263 9.69076Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95177 9.73851C6.92071 9.32864 7.24491 8.97896 7.65595 8.97896C8.06231 8.97896 8.38484 9.32105 8.36093 9.72671L8.08686 14.3774C8.07463 14.5849 7.90285 14.7468 7.69506 14.7468C7.48979 14.7468 7.3192 14.5887 7.30369 14.384L6.95177 9.73851Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2656 9.69162C9.24443 9.27955 9.57283 8.93384 9.98544 8.93384C10.3955 8.93384 10.723 9.27547 10.7056 9.68516L10.3921 17.0789C10.3836 17.279 10.2189 17.4368 10.0187 17.4368C9.8197 17.4368 9.65561 17.2809 9.6454 17.0822L9.2656 9.69162Z",
    stroke: "white",
    strokeWidth: 0.738389
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6263 9.69076C11.6009 9.28052 11.9268 8.93384 12.3378 8.93384C12.7466 8.93384 13.0716 9.27694 13.0495 9.68514L12.7279 15.633C12.7173 15.8278 12.5564 15.9802 12.3613 15.9802C12.1675 15.9802 12.007 15.8294 11.995 15.6359L11.6263 9.69076Z",
    stroke: "white",
    strokeWidth: 0.738389
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95177 9.73851C6.92071 9.32864 7.24491 8.97896 7.65595 8.97896C8.06231 8.97896 8.38484 9.32105 8.36093 9.72671L8.08686 14.3774C8.07463 14.5849 7.90285 14.7468 7.69506 14.7468C7.48979 14.7468 7.3192 14.5887 7.30369 14.384L6.95177 9.73851Z",
    stroke: "white",
    strokeWidth: 0.738389
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69579 8.2773C6.10978 8.13255 8.12432 7.63499 9.99934 7.63107C11.8753 7.63499 13.8903 8.13255 14.3043 8.2773C14.7978 8.44984 14.7835 8.92779 14.3564 9.11887C13.8355 9.3519 13.9762 10.0089 14.7645 9.96868C15.8386 9.91394 17.8935 7.85529 15.9722 5.33019C14.3032 3.13667 11.2326 2.56317 10.0001 2.56317C8.76756 2.56317 5.69693 3.13667 4.02791 5.33019C2.10663 7.85529 4.16149 9.91394 5.23555 9.96868C6.02395 10.0089 6.16462 9.3519 5.64373 9.11887C5.21659 8.92779 5.2023 8.44984 5.69579 8.2773Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.738389
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeParserHeaderDarkicon);
export default __webpack_public_path__ + "static/media/resume-parser-header-darkicon.a58bf3a0a222288f9cfae6345e04cf08.svg";
export { ForwardRef as ReactComponent };